// AUTO-GENERATED by tools/generate-world4-b.mjs. Do not edit by hand.
// Regenerate with: node tools/generate-world4-b.mjs
// W4 part B (L11-L20) — second pass, d=6-7 profile, different seed region.
import type { LevelDef } from '@tessera/engine';

export const WORLD_4B_GENERATED: LevelDef[] = [
  // d*=6  branching=14.61  D=0.026  tiles=10
  {
    id: 'w4-l11',
    world: 4,
    index: 11,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -1, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 2 },
    { coord: { q: 2, r: -3 }, color: 2 },
    ],
  },
  // d*=6  branching=16.44  D=0.117  tiles=11
  {
    id: 'w4-l12',
    world: 4,
    index: 12,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 2 },
    { coord: { q: 2, r: 1 }, color: 2 },
    ],
  },
  // d*=6  branching=21.15  D=0.164  tiles=11
  {
    id: 'w4-l13',
    world: 4,
    index: 13,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 1, r: 2 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -1, r: -2 }, color: 1 },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: 3, r: -3 }, color: 2 },
    ],
  },
  // d*=6  branching=21.35  D=0.166  tiles=11
  {
    id: 'w4-l14',
    world: 4,
    index: 14,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -3, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: 1, r: 2 }, color: 2 },
    ],
  },
  // d*=6  branching=21.68  D=0.168  tiles=11
  {
    id: 'w4-l15',
    world: 4,
    index: 15,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 3, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 2 },
    { coord: { q: 1, r: 2 }, color: 2 },
    ],
  },
  // d*=6  branching=21.68  D=0.168  tiles=11
  {
    id: 'w4-l16',
    world: 4,
    index: 16,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 2, r: 1 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 2 },
    { coord: { q: -3, r: 2 }, color: 2 },
    ],
  },
  // d*=6  branching=21.68  D=0.168  tiles=11
  {
    id: 'w4-l17',
    world: 4,
    index: 17,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -1, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 2, r: -3 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 2 },
    { coord: { q: 3, r: -1 }, color: 2 },
    ],
  },
  // d*=6  branching=21.68  D=0.168  tiles=11
  {
    id: 'w4-l18',
    world: 4,
    index: 18,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: -3, r: 1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -3, r: 0 }, color: 1 },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: 0, r: 3 }, color: 2 },
    ],
  },
  // d*=6  branching=22.12  D=0.169  tiles=11
  {
    id: 'w4-l19',
    world: 4,
    index: 19,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 3, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 0 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 2 },
    { coord: { q: 1, r: 2 }, color: 2 },
    ],
  },
  // d*=6  branching=18.81  D=0.172  tiles=11
  {
    id: 'w4-l20',
    world: 4,
    index: 20,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 8 },
    tiles: [
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -3, r: 1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: 3, r: -3 }, color: 0 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: -3, r: 3 }, color: 1 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 2 },
    { coord: { q: 3, r: 0 }, color: 2 },
    ],
  },
];
